import { StorageService } from '@/api'

// state
const state = () => ({
  all: [],
  settings: null,
})

// getters
const getters = {
  storagesByInventory(state, getters, rootState) {
    const byStore = []
    rootState.products.packages.forEach((item) => {
      const store = byStore.find((v) => v.name === item.properties.storage_name)
      if (!store) {
        const st = {
          name: item.properties.storage_name,
          items: [item],
        }
        byStore.push(st)
      } else {
        store.items.push(item)
      }
    })

    return byStore
  },
  availableForOrder(state, getters, rootState) {
    return getters.storagesByInventory.filter((store) => {
      const items = store.items
      let isAvailable = true
      rootState.cart.items.forEach((el) => {
        const matchedElements = items.find((v) => {
          return el.id == v.properties.main_product_id && +el.quantity <= +v.quantity_available
        })

        if (!matchedElements) {
          isAvailable = false
        }
      })

      // if (
      //   store.name === state.settings.pickUpStorageType &&
      //   rootGetters['cart/pickupPoints'] > rootState.cart.maxPickUpPointForKiosk
      // ) {
      //   isAvailable = false
      // }

      return isAvailable
    })
  },
  availableTypes(state, getters) {
    return getters.availableForOrder.map((v) => v.name)
  },
  availableStorages(state, getters) {
    return state.all.filter((v) => getters.availableTypes.indexOf(v.name) > -1)
  },
  selectedStorage(state, getters, rootState) {
    if (rootState.cart.deliverPlaceID && state.all) {
      return state.all.find((v) => v.id == rootState.cart.deliverPlaceID)
    } else {
      return null
    }
  },
}

// actions
const actions = {
  async getAll({ commit }, params) {
    const storages = await StorageService.getAll(params)
    commit('setAllStorages', storages.records)
  },
  async getSettings({ commit }) {
    const settings = await StorageService.getSettings()

    commit('setSettings', settings)
  },
}

// mutations
const mutations = {
  setAllStorages(state, storages) {
    state.all = storages
  },
  setSettings(state, settings) {
    state.settings = settings
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
